import { graphql } from 'react-relay';

const createWithdrawalRequestMutation = graphql`
  mutation CreateWithdrawalRequestMutation (
      $accountId: ID!
      $amount: Float!
      $currency: String!
      $bankAccountBsb: String
      $bankAccountId: ID
      $bankAccountName: String
      $bankAccountNumber: String
      $custodian: Custodian
  ) {
      createWithdrawalRequest(
          accountId: $accountId
          amount: $amount
          currency: $currency
          bankAccountBsb: $bankAccountBsb
          bankAccountId: $bankAccountId
          bankAccountName: $bankAccountName
          bankAccountNumber: $bankAccountNumber
          custodian: $custodian
      ) {
          cashTransferRequest {
              id
              amount
              currency
              status
              blocked
              account {
                  id
              }
          }
      }
  }
`;

export default createWithdrawalRequestMutation;
